/* LDS Guided slide-out cart. Loaded by snippets/lds-cart-drawer.liquid.
   Adds to Ignite's cart drawer: a free shipping bar (Canada) or the US duty note, the item count, a trust line,
   an "Empty cart" button (asks first), and a few places to start when the cart is empty.
   Puts them back whenever the theme re-renders the drawer.
   Free shipping is judged like on the cart page: items that ship, after discounts; installation services
   don't count, and a cart of only "Includes Installation" packages shows no bar. */
(function () {
  var cfg = window.LDS_DRAWER || {};
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  var goal = cfg.freeShip || 20000;
  var cart = null;
  var ticket = 0;
  var timer = null;

  function money(cents) {
    var value = cents / 100;
    var withDecimals = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (cfg.moneyFormat || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, withDecimals)
      .replace(/<[^>]*>/g, '');
  }

  function shipHtml(c) {
    var country = (window.Shopify && window.Shopify.country) || '';
    if (country === 'US') {
      return '<p class="ldd-us"><strong>Shipping to the US?</strong> Import duties are added at checkout, ' +
        'and on some products they\'re large right now. <a href="/pages/shipping-handling#ship-tariffs">See what\'s changed</a></p>';
    }
    if (country !== 'CA' || c.currency !== 'CAD') return '';
    var ship = 0;
    var all = 0;
    var parcel = false;
    c.items.forEach(function (item) {
      all += item.final_line_price;
      if (!item.requires_shipping) return;
      ship += item.final_line_price;
      if (String(item.product_title || '').indexOf('Includes Installation') === -1) parcel = true;
    });
    if (!parcel) return '';
    var orderDiscount = 0;
    (c.cart_level_discount_applications || []).forEach(function (d) { orderDiscount += d.total_allocated_amount || 0; });
    if (orderDiscount && all) ship -= Math.round(orderDiscount * ship / all);
    var left = goal - ship;
    var pct = Math.max(0, Math.min(100, Math.floor(ship * 100 / goal)));
    var msg = left <= 0
      ? '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M4 10.5l4 4 8-9" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Your order ships free in Canada.</span>'
      : '<span>Add <strong>' + money(left) + '</strong> more for free shipping in Canada.</span>';
    return '<div class="ldd-ship' + (left <= 0 ? ' is-free' : '') + '"><p class="ldd-ship__msg">' + msg +
      '</p><div class="ldd-ship__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div></div>';
  }

  // Writes only when something changed, so the observer below doesn't loop on our own edits.
  function put(parent, cls, before, html, tag) {
    var el = parent.querySelector(':scope > .' + cls);
    if (!el) {
      el = document.createElement(tag || 'div');
      el.className = cls;
      parent.insertBefore(el, before ? parent.firstChild : null);
    }
    if (el.getAttribute('data-key') !== html) {
      el.innerHTML = html;
      el.setAttribute('data-key', html);
    }
  }

  function emptyHtml() {
    var links = cfg.emptyLinks || [];
    if (!links.length) return '';
    return '<p class="ldd-empty__lead">Not sure where to start?</p><ul class="ldd-empty__links">' +
      links.map(function (l) { return '<li><a href="' + l[1] + '">' + l[0] + '</a></li>'; }).join('') +
      '</ul>' + (cfg.help ? '<p class="ldd-empty__help">' + cfg.help + '</p>' : '');
  }

  function toolsHtml(count) {
    var question = count === 1 ? 'Remove the item in your cart?' : 'Remove all ' + count + ' items?';
    return '<button type="button" class="ldd-clear" data-ldd-clear="ask">Empty cart</button>' +
      '<div class="ldd-confirm" role="group" aria-label="Empty cart" hidden><p>' + question + '</p>' +
      '<button type="button" class="ldd-mini ldd-mini--stop" data-ldd-clear="yes">Yes, empty it</button>' +
      '<button type="button" class="ldd-mini" data-ldd-clear="no">Keep them</button></div>';
  }

  function apply() {
    var empty = drawer.querySelector('.cart-drawer__empty-content');
    if (empty) put(empty, 'ldd-empty', false, emptyHtml());
    if (!cart) return;
    var footer = drawer.querySelector('.drawer__footer');
    if (footer) put(footer, 'ldd-ship-slot', true, shipHtml(cart));
    var ctas = drawer.querySelector('.drawer__footer .cart__ctas');
    if (ctas && cfg.trust) put(ctas, 'ldd-trust', false, cfg.trust.replace(/</g, '&lt;'), 'p');
    var list = drawer.querySelector('cart-drawer-items');
    if (list) put(list, 'ldd-tools', false, cart.item_count ? toolsHtml(cart.item_count) : '');
    var heading = drawer.querySelector('.drawer__heading');
    if (heading) put(heading, 'ldd-count', false, cart.item_count ? '(' + cart.item_count + ')' : '', 'span');
  }

  function load() {
    var mine = ++ticket;
    fetch((cfg.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (mine !== ticket) return;
        cart = c;
        apply();
      })
      .catch(function () {});
  }

  // Empties the cart and redraws the drawer in one request, the way the theme does after a change.
  // On the cart page, or if anything goes wrong, it falls back to reloading the page.
  function clearCart(btn) {
    btn.disabled = true;
    btn.textContent = 'Emptying…';
    var ids = typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (section) { return section.id; })
      : [];
    fetch(cfg.clearUrl || '/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ sections: ids.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('clear failed');
        return r.json();
      })
      .then(function (state) {
        if (!state.sections || typeof drawer.renderContents !== 'function' ||
          document.body.classList.contains('cart-template')) throw new Error('reload');
        cart = state;
        drawer.classList.add('is-empty');
        drawer.renderContents(state, true);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lds-cart-drawer', cartData: state });
        }
        setTimeout(function () {
          var next = drawer.querySelector('.drawer__inner-empty .button, .drawer__close');
          if (next) next.focus();
        }, 50);
      })
      .catch(function () { window.location.reload(); });
  }

  drawer.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-ldd-clear]');
    if (!btn) return;
    var tools = btn.closest('.ldd-tools');
    var ask = tools.querySelector('[data-ldd-clear="ask"]');
    var box = tools.querySelector('.ldd-confirm');
    var step = btn.getAttribute('data-ldd-clear');
    if (step === 'ask') {
      ask.hidden = true;
      box.hidden = false;
      box.querySelector('[data-ldd-clear="no"]').focus();
      box.scrollIntoView({ block: 'nearest' });
    } else if (step === 'no') {
      box.hidden = true;
      ask.hidden = false;
      ask.focus();
    } else if (step === 'yes' && !btn.disabled) {
      clearCart(btn);
    }
  });

  // When the theme re-renders the drawer: put the extras straight back with the last cart we know,
  // then fetch the cart again (the add-to-cart flow doesn't always announce itself).
  function schedule() {
    apply();
    clearTimeout(timer);
    timer = setTimeout(load, 150);
  }

  new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });

  // PUB_SUB_EVENTS is a global const in the theme, so it isn't on window.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }

  apply();
  load();
})();
